import { createBrowserRouter } from 'react-router-dom';

import { PRIVATE_PAGE_ROUTES } from '@/enums';
import { Layout } from '@/layout';
import { MfaSetup } from '@/pages';

import { MfaSetupRoute } from './MfaSetupRoute';
import { RouterFallback } from './RouterFallback';
import { privateRouteObjects } from './route-definitions/privateRoutes';
import { publicRoutes } from './route-definitions/publicRoutes';

export const router = createBrowserRouter([
  {
    element: <Layout />,
    children: privateRouteObjects
  },
  {
    path: PRIVATE_PAGE_ROUTES.MFA_SETUP,
    element: (
      <MfaSetupRoute>
        <MfaSetup />
      </MfaSetupRoute>
    )
  },
  ...publicRoutes,
  {
    path: '*',
    element: <RouterFallback />
  }
]);
